import React from 'react';
import ReactDOM from "react-dom/client";
import * as Sentry from '@sentry/react';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { initGlitchTip } from 'utils/glitchtip';
import './index.css';

initGlitchTip();

const ErrorFallback = () => (
  <div style={{ padding: 48, textAlign: 'center' }}>
    <h2>Something went wrong</h2>
    <button type="button" onClick={() => window.location.reload()}>Reload</button>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
    <App />
  </Sentry.ErrorBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
